export default {
  methods: {
    $notify(msg, cls=undefined) {
      this.global.notify = { msg, class: cls };
    }
  }
}
